import { computed, useTemplateRef } from 'vue';
import type MessageBuilder from '~/components/general/message-builder/MessageBuilder.vue';

export function useMessageBuilderInModal() {
    const messageBuilderRef = useTemplateRef<InstanceType<typeof MessageBuilder>>('messageBuilder');

    const stacked = computed(() => {
        if (!messageBuilderRef.value) {
            return false;
        }
        return messageBuilderRef.value.modalOpen;
    });

    const uploadingMedia = computed(() => Boolean(messageBuilderRef.value?.uploadingMedia));

    return {
        stacked,
        uploadingMedia,
    };
}
